import { Component, ElementRef, EventEmitter, OnInit, Output, Renderer2, ViewChild } from '@angular/core';
import { FormBuilder, FormControl, FormGroup, Validators } from '@angular/forms';
import { israelIDValidator } from 'src/app/validators/isarel-id.validator';
import { UpdateDetailsService } from 'src/app/core/services/update-details.service';
import { HttpHeaders } from '@angular/common/http';
import { SiteStettingService } from 'src/app/core/services/site-stetting.service';
import { Router } from '@angular/router';
import { Location } from '@angular/common';
import { AppConfigService } from 'src/app/core/services/app-config.service';
import { AppMessagesService } from 'src/app/core/services/app-messages.service';
import "../../../assets/scss/_form.scss"
import { AppServiceService } from 'src/app/core/services/app-service.service';








@Component({
  selector: 'app-login-via-sms',
  templateUrl: './login-via-sms.component.html',
  styleUrls: ['./login-via-sms.component.scss']
})
export class LoginViaSMSComponent implements OnInit {
  @Output() loginViaPassword = new EventEmitter();
  @Output() sendOtp = new EventEmitter<string>();
  idCardForm: FormGroup;
  verificationCodeForm: FormGroup;
  phoneCodeOptions;
  showPopupCard: boolean = false;
  message: string = "";
  restartcode: boolean;
  phoneNumberWithAsterisks: string;
  verificationCodeInvalid: boolean;
  HTMLContent = "<p>כדי שנוכל לזהות אותך, אנו זקוקים לכל 9 הספרות של ת.ז שלך, כולל ספרת ביקורת. אם אין לך ת.ז, אנו זקוקים למספר הדרכון שלך המורכב מ 16 ספרות ואותיות.</p>";
  flagToOption: boolean = true;
  sitekey: string;
  CaptchaNeeded: boolean;
  loader: boolean = false;
  links: any;
  updatePhone: string;
  service: any;
  loginType:any;
  isValidFormSubmitted:boolean = false;
  isValidFormSubmittedPhone:boolean = false;
  userId:string;
  isOpened:boolean = false;

  constructor(private updateDetailsService: UpdateDetailsService, private formBuilder: FormBuilder 
    , private _siteSettingService: SiteStettingService, private _router: Router,private appService:AppServiceService,private renderer: Renderer2,
     private location: Location, private appConfigService: AppConfigService, private appMessagesService: AppMessagesService ,private elementRef: ElementRef) { }
  get idCard() {
    return this.idCardForm.controls.idCard;
  }


  get phoneNumber() {
    return this.idCardForm.controls.phoneNumber;
  }

  get phoneCode() {
    return this.idCardForm.controls.phoneCode;
  }
  
  ngOnInit(): void {
    document.getElementById("idCard").focus();
    this.service = this.appConfigService.service;
    this.appService.componentName = 'login-via-sms-component';
    this.loginType = this.appService.loginType;
    this.appConfigService.getLinks().subscribe(
      (data) => {
        this.links = data;
      },
      (error) => {
        //TODO
      })
    this.updatePhone = this.links.updateDetails;
    this.sitekey = window['_siteSettings'].recaptchaSiteKey;
    this.service.restartLogin().subscribe(data => {
    this.CaptchaNeeded =this._siteSettingService.CaptchaNeeded = data.isCaptchaNeeded;
    }, err => {
    });

    this.updateDetailsService.getPhoneCode().subscribe(mobilePrefix => {
      this.phoneCodeOptions = mobilePrefix;
    });

    this.idCardForm = this.formBuilder.group({
      idCard: new FormControl('', { validators: [Validators.required, israelIDValidator] }),
      phoneCode: new FormControl('', { validators: [Validators.required, Validators.minLength(3), Validators.maxLength(3)] }),
      phoneNumber: new FormControl('', { validators: [Validators.required, Validators.minLength(7), Validators.maxLength(7)] }),
    });

    this.idCardForm.valueChanges.subscribe(value => {
      const phoneCodeValue = value['phoneCode'];
      const phoneNumberValue = value['phoneNumber']
      const idCardValue = value['idCard'];
      this.appService.setFieldStatus(idCardValue?.trim().length > 0 || phoneCodeValue?.trim().length > 0 ||phoneNumberValue.trim().length > 0);
    });


    this.verificationCodeForm = this.formBuilder.group({
      verificationCode: new FormControl('', { validators: [Validators.required, Validators.minLength(4)] }),
    });
    
  }

  changeFlag() {
    this.flagToOption = false;
  }
  
  resolved(captchaResponse: string) {
    var res = '';
    res = grecaptcha.getResponse();
  }

  onSubmit(captchaResponse?: any) {
      //  if(this.phoneNumber.errors  && !this.phoneCode.errors || !this.phoneNumber.errors  && this.phoneCode.errors){
      //   this.isValidFormSubmittedPhone = true;
      //   return;
      // }

   //else 
    if (this.idCardForm.invalid) { 
        
        this.isValidFormSubmitted = true;
        grecaptcha.reset();
        document.getElementById("idCard").focus();
        return;
     }
    this.loader = true;
    if (captchaResponse == undefined){
      captchaResponse = " ";
    }
      this.userId = this.idCardForm.value.idCard.padStart(9, '0');
      this.service.loginWithIdAndMobile( this.userId, this.idCardForm.value.phoneCode + this.idCardForm.value.phoneNumber, captchaResponse).subscribe(data => {
      if (data){
      this.CaptchaNeeded = this._siteSettingService.CaptchaNeeded = data.isCaptchaNeeded;
      if (data.isError == false) {//otpDestMasked
      if(window['_loginType'] ==window['_loginTypeOTPOnly']){      
        this.appService.mobileOtp = data.otpDestMasked
       this._router.navigate(['loginOtpOnlyOtp'],{skipLocationChange: true}) 
      }
      else{
        this.appService.setFieldStatus(false);
        this.sendOtp.emit(data.otpDestMasked);
        this.loader = false;
      }
        //this.phoneNumberWithAsterisks = data.otpDestMasked;
      }
      else {
        this.message = this.appMessagesService.returnErrorMessage(data.errorCode);
        this.idCardForm.reset();
        document.getElementById("idCard").focus();
        this.isValidFormSubmitted = false;
      }
    }
    },
      err => {
      })
      .add(() => {
        grecaptcha.reset();
        this.loader = false;
      });

  }
  resetMassage(){
    this.message = "";
  }
  
  focuseDropdwon(){
    document.getElementById("phoneCodeDrop").focus();  
  }
    handleDropdownKeydown(event: KeyboardEvent ) {
      if (event.shiftKey && event.key === 'Tab') {
        event.preventDefault();
        document.getElementById("idCard").focus();
      }
     else  if (event.key === 'Tab') {
       event.preventDefault();
       document.getElementById("phoneNumber").focus();

      }
    if(event.key === 'Enter' ){
      document.getElementById("phoneCodeDrop").click();   
    }
    }
    handlePhoneNumberKeyDown(event: KeyboardEvent){
      
      const dropdownElementId = (event.target as HTMLElement).id;
      if (event.shiftKey && event.key === 'Tab') {
        event.preventDefault();
        document.getElementById("phoneCodeDrop").focus();   
      }
       else if (event.key === 'Tab' && dropdownElementId === "phoneNumber") {
        event.preventDefault();
        this.elementRef.nativeElement.querySelector('button').focus();    
        }
         
   
    }
    handleIdCardKeyDown(event: KeyboardEvent ){
     const dropdownElementId = (event.target as HTMLElement).id;
   if (event.key === 'Tab' && !event.shiftKey && dropdownElementId === "idCard") {
          event.preventDefault();
          document.getElementById("phoneCodeDrop").focus();        }
     
    }
    KeyDownButton(event: KeyboardEvent){
      if (event.shiftKey && event.key === 'Tab') {
        event.preventDefault();
        document.getElementById("phoneNumber").focus();
      }
    }
  openPopup() {
    this.showPopupCard = true;
  }
  closePopup() {
    this.showPopupCard = false;
  }

  handleDropdownClick(){
  if(this.message!='') {
    this.message = "";
  }
  this.isValidFormSubmitted = false;
  this.isValidFormSubmittedPhone = false;
}
  loginByPassward() {
    this.loginViaPassword.emit();
  }

}
